import { DialogContent as MuiDialogContent } from 'transfix-ui/core'
import { withStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'

export const DialogContent = withStyles(theme => ({
  root: {},
  dividers: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${brandColors.coolGray2}`,
    borderBottom: `1px solid ${brandColors.coolGray2}`,
  },
}))(MuiDialogContent)
